/* eslint-disable @typescript-eslint/no-misused-promises */
import NeedleAnalyticsApiService from '@package/core/src/needleAnalytics/NeedleAnalyticsApiService';
import NeedleAnalyticsInteractor from '@package/core/src/needleAnalytics/NeedleAnalyticsInteractor';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import {needleAnalytic } from '../services';

const needleService = new NeedleAnalyticsApiService(needleAnalytic);
const needleInteractor = new NeedleAnalyticsInteractor(needleService);

export default function useCheckoutNeedle() {
  const router = useRouter();

  const handleStartLoading = async () => {
    await needleInteractor.removeNeedleScript();
  };

  const handleEndLoading = async () => {
    await needleInteractor.reloadNeedleScript();
  };

  useEffect(() => {
    router.events.on('routeChangeStart', handleStartLoading);
    router.events.on('routeChangeComplete', handleEndLoading);
  }, []);

  return {};
}
